exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-settings[data-v-f79e9988]{width:100%;max-width:200px;display:block;margin:0 auto}", ""]);

// exports
